import React, { useState, useCallback } from 'react';
import { Table, TableSize } from '@ui';
import { translate } from '@utils/i18n';
import { useAllowedUsers } from '../../hooks/useAllowedUsers';
import './UserAccessTableStyles.scss';
const namespace = 'features.settings.ip_assistant';
const SORTABLE_COLUMNS = ['name', 'username', 'role'];
function UserAccessTable() {
    const [page, setPage] = useState(1);
    const [sortBy, setSortBy] = useState('name');
    const [sortDir, setSortDir] = useState('asc');
    const { data } = useAllowedUsers(page, { sortBy, sortDirection: sortDir });
    const users = (data === null || data === void 0 ? void 0 : data.users) || [];
    const meta = data === null || data === void 0 ? void 0 : data.meta;
    const columns = [
        { dataKey: 'name', label: translate('column_name', { namespace }) },
        { dataKey: 'username', label: translate('column_username', { namespace }) },
        { dataKey: 'role', label: translate('column_role', { namespace }) }
    ];
    const handleSort = useCallback((dataKey, direction) => {
        setSortBy(dataKey);
        setSortDir(direction);
        setPage(1);
    }, []);
    if (!meta || meta.totalCount === 0)
        return null;
    return (React.createElement("div", { className: "ip-assistant-user-access-table" },
        React.createElement(Table, { size: TableSize.Full, data: users, columns: columns, variant: "listing", sortable: true, sortableColumns: SORTABLE_COLUMNS, sortBy: sortBy, sortDirection: sortDir, onSort: handleSort, onPageChange: setPage, serverCurrentPage: meta.currentPage, serverTotalPages: meta.totalPages, serverTotalItems: meta.totalCount, pageSize: meta.perPage, getItemId: (user) => `${user.userType}:${user.id}` })));
}
export default UserAccessTable;
